import { z } from 'zod';
import { UTM_PARAMS } from '~/constants';

export const UtmDataSchema = z.object({
  utm_source: z.string().optional(),
  utm_medium: z.string().optional(),
  utm_campaign: z.string().optional(),
  utm_content: z.string().optional(),
  utm_term: z.string().optional(),
  first_touch_url: z.string(),
});

export type UtmData = z.infer<typeof UtmDataSchema>;

/**
 * Parse UTM parameters and first_touch_url from a full URL string.
 */
export function parseUtmParams(url: string): UtmData {
  const urlObj = new URL(url);
  const params: Partial<UtmData> = {};

  for (const param of UTM_PARAMS) {
    const value = urlObj.searchParams.get(param);

    if (value) {
      params[param] = value;
    }
  }

  return UtmDataSchema.parse({
    ...params,
    first_touch_url: url,
  });
}

/**
 * Derive lead_source from UTM data.
 * Returns utm_source if present, otherwise 'organic_or_direct'.
 */
export function deriveLeadSource(utmData: Partial<UtmData>): string {
  return utmData.utm_source || 'organic_or_direct';
}
